import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import * as campanhaActions from '../../store/modules/backoffice/campanha/actions'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import { ApplicationState } from 'store'
import { CAMPANHA } from 'store/modules/backoffice/campanha/types'
import useRedux from 'hooks/useRedux'

const ModalAtivarDesativarCampanha = () => {
  const { modalAtivarDesativar, acaoModal, codigoCampanhaDiscador } =
    useSelector<ApplicationState, CAMPANHA>((state) => state.campanha)
  const { dispatch } = useRedux()

  const modalConfig = {
    iniciar: {
      titulo: 'Iniciar Campanha',
      mensagem: 'Deseja realmente iniciar esta campanha?'
    },
    pausar: {
      titulo: 'Pausar Campanha',
      mensagem: 'Deseja realmente pausar esta campanha?'
    },
    'tentar-novamente': {
      titulo: 'Tentar Novamente',
      mensagem: 'Deseja realmente tentar novamente esta campanha?'
    },
    'cancelar-campanha': {
      titulo: 'Cancelar Campanha',
      mensagem: 'Deseja realmente cancelar esta campanha?'
    }
  } as const

  const currentModalConfig = acaoModal ? modalConfig[acaoModal] : null

  const handleConfirm = () => {
    if (!codigoCampanhaDiscador || !acaoModal) return

    dispatch(campanhaActions.confirmarAcaoCampanhaSaga())
  }

  const toggleModal = () => {
    campanhaActions.toggleModalAtivarDesativarDispatch(false)
  }

  return (
    <Modal isOpen={modalAtivarDesativar}>
      <ModalHeader toggle={toggleModal}>
        <SimpleTitleCard colorIcon="F7931E">
          <AiOutlineExclamationCircle className="icon" />
          {currentModalConfig?.titulo || 'Confirmar Ação'}
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <p>{currentModalConfig?.mensagem || 'Deseja confirmar esta ação?'}</p>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Row className="d-flex column-gap-20">
          <CustomButton onClick={toggleModal} background="#662D91">
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleConfirm}>Confirmar</CustomButton>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default ModalAtivarDesativarCampanha
